import React, { Component } from 'react';
import PropTypes from 'prop-types';

class VxCheckboxField extends Component {
	static propTypes = {
		input: PropTypes.object,
		label: PropTypes.string,
		meta: PropTypes.object,
		id: PropTypes.string,
		disabled: PropTypes.bool,
	};

	render() {
		const {
			input,
			label,
			meta: { touched, error },
			id
		} = this.props;
		
		const hasError = touched && error;
		const isDisabled = !!this.props.disabled;

		return (
			
				<div className={`vx_checkbox ${hasError ? 'vx_has-error' : ''} ${isDisabled ? 'vx_is-disabled' : ''}`}>
					<input
						{...input}
						type="checkbox"
						id={id}
						disabled={isDisabled}
					/>
					<label htmlFor={id || name}>{label}</label>
				</div>
			
		);
	}
}
export default VxCheckboxField;



// WEBPACK FOOTER //
// ./buttons/components/vxFields/VxCheckboxField.js